import type { ShipmentResponse } from '../../api/types';
import { findTruckType } from '../../config/truckCatalog';

type ShipmentTruck = Pick<ShipmentResponse, 'vehicleTypeRequired' | 'vehicleTypeName' | 'vehicleTypeOther'>;
type Lookup = (id: string) => { name: string } | undefined;

const bundled: Lookup = (id) => findTruckType(id)?.truck;
const clean = (v: string | null | undefined) => (v ?? '').trim();

/**
 * The one display rule for a shipment's truck (#249 Contract section 4): the server's catalog
 * name → "Other: <typed text>" → a catalog lookup of the id (older API). Null when none applies.
 */
export function truckTypeName(s: ShipmentTruck, find: Lookup = bundled): string | null {
  const name = clean(s.vehicleTypeName);
  if (name) return name;
  const other = clean(s.vehicleTypeOther);
  if (other) return `Other: ${other}`;
  const id = clean(s.vehicleTypeRequired);
  return id ? (find(id)?.name ?? null) : null;
}

/** `truckTypeName`, then the raw stored value (legacy free text), then a dash. */
export function truckTypeLabel(s: ShipmentTruck, find: Lookup = bundled): string {
  return truckTypeName(s, find) ?? (clean(s.vehicleTypeRequired) || '—');
}
